module.exports = __webpack_public_path__ + "static/media/Logo.8d124118.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Logo.png
// module id = 1012
// module chunks = 0